import {
  Box,
  Button,
  Col,
  Colors,
  IcPlus,
  InputSearch,
  Row,
  Text,
} from 'basic-ui-lib';
import { debounce } from 'lodash';
import useGetPlaylistsInStore from 'modules/store/services/hooks/useGetPlaylistsInStore';
import { useEffect, useMemo, useState } from 'react';
import styled from 'styled-components';

interface PlaylistHeaderProps {
  onNewPlaylist: () => void;
  id: string;
}

const PlaylistHeader = ({ onNewPlaylist, id }: PlaylistHeaderProps) => {
  const { mutate } = useGetPlaylistsInStore(id, true);
  const [searchText, setSearchText] = useState<string | undefined>(undefined);

  const debouncedSearch = useMemo(
    () =>
      debounce((value: string) => {
        mutate({
          keySearch: value,
          page: 1,
          size: 10,
        });
      }, 500),
    [mutate],
  );

  useEffect(() => {
    if (searchText === undefined) return;
    debouncedSearch(searchText);

    return () => {
      debouncedSearch.cancel();
    };
  }, [searchText, debouncedSearch]);

  return (
    <Container>
      <Col gap={2}>
        <Text title_h5 semibold left>
            Playlist
        </Text>
        <Text body_1 medium left color='neutral.text.3'>
          Create and manage content shown on your screens
        </Text>
      </Col>
      <Row flex={1} gap={16} alignItems='center' justifyContent='flex-end'>
        <Box width='40%'>
          <InputSearch
            value={searchText}
            placeholder='Search screens by name, location,...'
            onChange={(value) => setSearchText(value)}
          />
        </Box>
        <Button
          lg
          type_second
          prefix={<IcPlus width={20} height={20} fill={Colors.neutral.bg[1]} />}
          onClick={onNewPlaylist}
          className='add-screen-button'
        >
          New Screen
        </Button>
      </Row>
    </Container>
  );
};

export default PlaylistHeader;

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  margin-top: 16px;
`;
